import styles from '@features/b2b-contact-form/styles/VideoBanner.module.css';
import ReactPlayer from 'react-player';
import cn from 'classnames';
import React from 'react';

import { getDirFromLocale, isRTL } from '@entities/language/model/utils';
import { B2BLanguageDropdown } from '@features/b2b-contact-form/ui/B2BLanguageDropdown';
import { useAtomValue } from 'jotai';
import { languageAtom } from '@shared/store/slice-atoms';
import { useTranslation } from 'react-i18next';

export const VideoBanner: React.FC = () => {
  const { t } = useTranslation();
  const language = useAtomValue(languageAtom);

  return (
    <div className={styles.wrapper} dir={getDirFromLocale(language.locale)}>
      <div className={styles.language_wrapper} dir={'ltr'}>
        <B2BLanguageDropdown />
      </div>
      <h1
        className={cn(styles.title, {
          [styles.titleRight]: isRTL(language.direction),
        })}
      >
        {t('b2b_banner_title')}
      </h1>

      <ReactPlayer
        url="https://d2rwz7a7lb9mw2.cloudfront.net/landingpage/videos/vuz_on_apple_vision_pro.mp4"
        playing
        loop
        volume={0}
        muted
        playsinline
        width="100%"
        className={styles.videoFrame}
      />
    </div>
  );
};
